<template>
    <div class="box">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>日志管理</el-breadcrumb-item>
            <el-breadcrumb-item>操作日志</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <h1 style="text-align:left;color:rgb(102, 102, 102)">{{authoName}}</h1>
        <el-form :inline="true" class="user-search" style="text-align: left;padding-top: 20px">
            <el-form-item label="">当前授权</el-form-item>
            <el-form-item label="" prop="SearchKey">
                <el-select v-model="authorizeModel.SearchKey" @change="handleSearchLog" filterable remote reserve-keyword placeholder="请选择授权" :remote-method="remoteMethod2" :disabled="isdisabled">
                    <el-option v-for="item in authoList" :key="item.OID" :label="item.Name" :value="item.OID">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="选择单位" prop="CompanyID">
                <el-select v-model="companyModel.SearchKey" @change="handleSearchCompany" filterable remote reserve-keyword placeholder="请输入单位查询" :remote-method="remoteMethod2" :disabled="isdisabled">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="item in companyList" :key="item.OID" :label="item.Name" :value="item.Code">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关键词" prop="SearchKey">
                <el-input placeholder="请输入关键词" v-model="logModel.SearchKey"></el-input>
            </el-form-item>
            <el-form-item label="时间" prop="SearchKey">
                <div class="block">
                    <el-date-picker value-format="yyyy-MM-dd" :picker-options="Time" v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleTimeChange">
                    </el-date-picker>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </el-form-item>
        </el-form>
        <!-- 列表 -->
        <el-table border default-expand-all :data="dataList" style="width: 100%" highlight-current-row :default-sort="{prop: 'date', order: 'descending'}">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column prop="WorkID" label="授权ID" sortable width="100">
            </el-table-column>

            <el-table-column prop="Path" label="请求地址" sortable width="300">
            </el-table-column>
            <el-table-column prop="Parameters" label="请求参数" sortable width="300">
                <template slot-scope="scope">
                    <span>{{scope.row.Parameters.substring(0,100)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="CompanyCode" label="请求单位" sortable width="200">
            </el-table-column>
            <el-table-column prop="OperateType" label="操作类型" sortable width="200">
            </el-table-column>
            <el-table-column prop="UserLoginID" label="登录账号" sortable width="200">
            </el-table-column>
            <el-table-column prop="UserName" label="登录人姓名" sortable width="200">
            </el-table-column>
            <el-table-column prop="Milliseconds" label="响应时长" sortable width="200">
            </el-table-column>
            <el-table-column prop="IP" label="请求IP" sortable width="300">
            </el-table-column>
            <el-table-column prop="Content" label="操作描述" sortable width="300">
            </el-table-column>
            <el-table-column prop="CreateTime" label="操作时间" sortable width="300">
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: left;padding-top: 10px">
            <el-pagination background @current-change="handleCurrentChange" :current-page="logModel.Page" layout="total,prev, pager, next, jumper" :total="listCount" :page-size="logModel.Rows">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
    import { GetSysLogList } from '../../api/log'
    import { GetWorkSQList } from '../../api/authorize'
    import { GetCompanyList } from '../../api/company'
    export default {
        data() {
            return {
                isShowAdd: false,
                isShowEdit: false,
                listCount: null,
                dataList: [],
                authoList: [],
                authoName: null,
                editData: [],
                isdisabled: false,
                isShow: true,
                logModel: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: '',
                    WorkID: null,
                    CompanyCode: '',
                    StartTime: '',
                    EndTime: ''
                },
                authorizeModel: {
                    Page: 1,
                    Rows: 100,
                    SearchKey: ''
                },
                companyModel: {
                    Page: 1,
                    Rows: 10,
                    SearchKey: ''
                },
                companyList: [],
                value1: '',
                Time: {
                    disabledDate: time => {
                        console.log(Date.now())
                        let year = new Date().getFullYear();
                        let mounth = new Date().getMonth() + 1;
                        let day = new Date().getDate();
                        if (mounth < 10) {
                            mounth = '0' + mounth;
                        }
                        if (day < 10) {
                            day = '0' + day;
                        }
                        let endTime = year + '-' + mounth + '-' + (Number(day) + 1);
                        let a = new Date(endTime).getTime();
                        return time.getTime() > a;
                    }
                },
            }
        },
        watch: {
            'logModel.SearchKey': {
                handler(newVal) {
                    if (newVal === '') {
                        this.logModel.SearchKey = '';
                        this.GetSysLogList();
                    }
                }
            }
        },
        mounted() {
            this.getTime();
            GetWorkSQList(this.authorizeModel).then(data => {
                if (!data.iserror) {
                    this.authoList = data.data.List;
                    this.logModel.WorkID = data.data.List[0].OID;
                    this.authorizeModel.SearchKey = data.data.List[0].OID;
                    this.authoList.forEach(item => {
                        if (item.OID === this.logModel.WorkID) {
                            this.authoName = item.Name
                        }
                    })
                    this.GetSysLogList();
                }
            })
        },
        methods: {
            handleSearchLog(val) {
                this.authoList.forEach(item => {
                    if (item.OID === val) {
                        this.authoName = item.Name
                    }
                })
                this.logModel.WorkID = val;
                this.logModel.Page = 1;
                this.GetSysLogList();
            },
            GetWorkSQList() {
                GetWorkSQList(this.authorizeModel).then(data => {
                    if (!data.iserror) {
                        this.authoList = data.data.List;
                    }
                })
            },
            GetSysLogList() {
                GetSysLogList(this.logModel).then(data => {
                    if (!data.iserror) {
                        this.dataList = data.data.List;
                        this.listCount = data.data.Count;
                    }
                })
            },
            handleCurrentChange(val) {
                this.logModel.Page = val;
                this.GetSysLogList();
            },
            handleSearch() {
                this.logModel.Page = 1;
                this.GetSysLogList();
            },
            handleAdd() {
                this.isShowAdd = true;
            },
            handleEdit(row) {
                this.editData = row;
                this.isShowEdit = true;
            },
            handleCloseEdit() {
                this.isShowEdit = false;
            },
            handleCloseAdd() {
                this.isShowAdd = false;
            },
            handleSearchCompany(val) {
                this.logModel.CompanyCode = val;
                this.GetSysLogList();
            },
            GetCompanyList() {
                GetCompanyList(this.companyModel).then(data => {
                    if (!data.iserror) {
                        this.companyList = data.data.List;
                    }
                })
            },
            remoteMethod2(query) {
                this.companyModel.SearchKey = query;
                this.GetCompanyList();
            },
            handleTimeChange(val) {
                this.logModel.StartTime = val[0];
                this.logModel.EndTime = val[1];
                this.GetSysLogList();
            },
            getTime() {
                console.log('获取时间')
                let year = new Date().getFullYear();
                let mounth = new Date().getMonth() + 1;
                let day = new Date().getDate();
                if (mounth < 10) {
                    mounth = '0' + mounth;
                }
                if (day < 10) {
                    day = '0' + day;
                }
                let startTime = year + '-' + mounth + '-' + day;
                let torrow = new Date();
                torrow.setTime(torrow.getTime() + 24 * 60 * 60 * 1000);
                let endTime = torrow.getFullYear() + "-" + (torrow.getMonth() + 1) + "-" + torrow.getDate();
                this.logModel.StartTime = startTime;
                this.logModel.EndTime = endTime;
                this.value1 = [startTime, endTime];
            }
        }
    }
</script>

<style>
    .el-icon-circle-close:before {
        color: #ffffff;
    }
</style>